import {
  Anchor,
  Button,
  Card,
  Center,
  Divider,
  Stack,
  ThemeIcon,
  Title,
  TypographyStylesProvider,
  Image,
} from "@mantine/core";

import React from "react";
import DocsHighlightCard from "../articlesHelpers/DocsHighlightCard";
import { IconFileInvoice, IconKey } from "@tabler/icons-react";
import DocsButton from "../articlesHelpers/DocsButton";
import SimpleImage from "../articlesHelpers/SimpleImage";

export const SEND_TO_KEYSEND_CONTENT = (
  <TypographyStylesProvider>
    <DocsButton
      ariaLabel="send to keysend"
      text="Keysend Payment"
      leftSection={<IconKey />}
    />
    <p>Keysend payments should be considered experimental.</p>
    <p>
      For a keysend payment, all you need is the public key of a node, which
      looks like this:
    </p>
    <pre>
      0322d0e43b3d92d30ed187f4e101a9a9605c3ee5fc9721e6dac3ce3d7732fbb13e
    </pre>

    <p>There are a few potential problems with keysend payments however:</p>
    <ol>
      <li>A node has to explicitly opt-in to receiving keysend payments.</li>
      <li>
        A node must have PUBLIC channels with sufficient inbound capacity.
      </li>
      <li>
        These PUBLIC channels need at least six confirmations and have to be
        well-known on the network.
      </li>
    </ol>

    <p>
      Given that, if you have the public key of a node, you can always try to
      send a keysend payment to see if it will work.
    </p>

    <p>
      You will first be prompted to enter the 66-character public key of the
      node you want to send a payment to:
    </p>
    <SimpleImage h={150} src="docs_images/keysend-entry.png" />
    <p>
      Rizful Node will then check the Lightning Network to see if this node has
      keysend enabled....
    </p>

    <SimpleImage h={150} src="docs_images/keysend-not-enabled.png" />

    <p>
      In some cases, you'll find that the node does not have keysend enabled.
    </p>
    <p>
      If the node DOES have keysend enabled, you'll be prompted to enter the
      amount you want to send, and other details:
    </p>
    <SimpleImage h={400} src="docs_images/keysend-payment.png" />
  </TypographyStylesProvider>
);
